import { after as f } from "../../function/after.js";
import { noop as i } from "../../function/noop.js";
import { isEqualWith as p } from "../../predicate/isEqualWith.js";
function m(r, o) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : i;
  return typeof t != "function" && (t = i), p(r, o, function () {
    var n = t.apply(void 0, arguments);
    if (n !== void 0) return !!n;
    if (r instanceof Map && o instanceof Map) return m(Array.from(r), Array.from(o), f(2, t));
    if (r instanceof Set && o instanceof Set) return m(Array.from(r), Array.from(o), f(2, t));
  });
}
export { m as isEqualWith };